import { render, staticRenderFns } from "./DownloadChart.vue?vue&type=template&id=12476d58"
import script from "./DownloadChart.vue?vue&type=script&lang=ts"
export * from "./DownloadChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports